import {
  Locale,
  createTranslate,
  createNumberFormat,
  createDateTimeFormat,
} from '@ha/intl';
import UrlResolver from 'ha/helpers/UrlResolver';
import { IntlConfig, IntlObject } from './types';

export default function createIntl({
  lang,
  baseDomain,
  messages,
}: IntlConfig): IntlObject {
  const locale = Locale[lang];

  return {
    lang,
    locale,
    messages,
    ...createTranslate(messages),
    ...createNumberFormat(locale),
    ...createDateTimeFormat(locale),
    urlResolver: UrlResolver.create({
      baseDomain,
      lang,
    }),
  };
}
